<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
  >
    <path
      d="M9.74345 9.27441C8.47976 11.1819 6.23298 12.3029 3.95126 12.2119C3.63892 12.2115 3.00548 12.2122 2.69283 12.2119L0.666992 13.9993H9.74345L12.667 9.27441H9.74345Z"
      :fill="fill_top"
    ></path>
    <path
      d="M4.23031 11.2749C5.88703 11.2792 7.49953 10.5282 8.56656 9.27492H5.99969V4.18617L9.88406 2.36273L5.06219 0.0996094V9.5643L3.53125 11.2749H4.23031Z"
      :fill="fill_bottom"
    ></path>
  </svg>
</template>

<script setup lang="ts">
interface IProps {
  fill_top?: string;
  fill_bottom?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IProps>(), {
  fill_top: "#2FB925",
  fill_bottom: "#FFE400",
  width: 16,
  height: 16,
});
</script>

<script lang="ts">
export default {};
</script>
